export enum ENV_LIST {
    LOCAL = 'local',
    STAGING = 'staging',
    REVIEW_APP = 'review_app',
    SANDBOX = 'sandbox',
    PRODUCTION = 'production',
}

export enum AvailableToggleFeatures {
    welcome_page = 'welcome_page',
    automatic_data_completion = 'automatic_data_completion',
    transport_pricing_enabled = 'transport_pricing_enabled',
    pickup_points = 'pickup_points',
    tour_incidents = 'tour_incidents',
}

const featuresByEnv = Object.freeze({
    // Usage example:
    // [ENV_LIST.LOCAL]: [AvailableToggleFeatures.ma_feature]
    [ENV_LIST.LOCAL]: [
        AvailableToggleFeatures.welcome_page,
        AvailableToggleFeatures.automatic_data_completion,
        AvailableToggleFeatures.transport_pricing_enabled,
        AvailableToggleFeatures.pickup_points,
        AvailableToggleFeatures.tour_incidents,
    ],
    [ENV_LIST.STAGING]: [
        AvailableToggleFeatures.welcome_page,
        AvailableToggleFeatures.automatic_data_completion,
        AvailableToggleFeatures.transport_pricing_enabled,
        AvailableToggleFeatures.pickup_points,
        AvailableToggleFeatures.tour_incidents,
    ],
    [ENV_LIST.REVIEW_APP]: [
        AvailableToggleFeatures.welcome_page,
        AvailableToggleFeatures.automatic_data_completion,
        AvailableToggleFeatures.transport_pricing_enabled,
        AvailableToggleFeatures.pickup_points,
        AvailableToggleFeatures.tour_incidents,
    ],
    [ENV_LIST.SANDBOX]: [AvailableToggleFeatures.welcome_page, AvailableToggleFeatures.transport_pricing_enabled],
    [ENV_LIST.PRODUCTION]: [AvailableToggleFeatures.welcome_page, AvailableToggleFeatures.transport_pricing_enabled],
});

export function getEnabledFeaturesByEnv(envName: ENV_LIST) {
    return featuresByEnv?.[envName];
}
